import { compose, pathOr, pick, path } from 'ramda'
import { createAction, createReducer } from 'redux-act'
import { loop, Effects } from 'redux-loop'

import { showModal } from 'redux/modules/modal'

export {
  notificationsSelector,
  filtersSelector,
  checkedItemsSelector,
  notificationsNotViewedSelector,
  errorMessageSelector
} from './selector'

const initialState = {
  isLoaded: false,
  isLoading: false,
  notifications: [],
  filters: {},
  query: {},
  checkedItems: []
}

const errorText = 'Неизвестная ошибка, повторите попытку позже.'

export const fetchNotifications = createAction(
  'notifications/FETCH_NOTIFICATIONS'
)
export const fetchNotificationsSuccess = createAction(
  'notifications/FETCH_NOTIFICATIONS_SUCCESS'
)
export const fetchNotificationsFailure = createAction(
  'notifications/FETCH_NOTIFICATIONS_FAILURE'
)
export const setNotificationsChecked = createAction(
  'notifications/SET_NOTIFICATIONS_CHECKED'
)

export const markNotificationsViewed = createAction(
  'notifications/MARK_NOTIFICATIONS_VIEWED'
)
export const markNotificationsViewedSuccess = createAction(
  'notifications/MARK_NOTIFICATIONS_VIEWED_SUCCESS'
)
export const markNotificationsViewedFailure = createAction(
  'notifications/MARK_NOTIFICATIONS_VIEWED_FAILURE'
)

const requestNotifications =
  ({ clientApi }) =>
    params =>
      clientApi
        .get('/v3/event/history/', { params })
        .then(fetchNotificationsSuccess)
        .catch(fetchNotificationsFailure)

const requestMark =
  ({ clientApi }) =>
    ({ params, filters }) =>
      clientApi
        .post('/v3/event/mark_as_read/', {
          params: { ...params, contractor_id: clientApi.getContractorId() }
        })
        .then(data => markNotificationsViewedSuccess({ data, filters }))
        .catch(markNotificationsViewedFailure)

const handleFetchNotifications = (state, payload, { clientApi }) =>
  loop(
    {
      ...state,
      isLoaded: true,
      isLoading: true
    },
    Effects.promise(requestNotifications({ clientApi }), payload)
  )

const handleFetchNotificationsSuccess = (state, payload) => ({
  ...state,
  isLoaded: true,
  isLoading: false,
  notifications: pathOr([], ['data', 'response', 'ITEMS'], payload),
  filters: compose(
    pick(['AGGREGATION', 'ENTITIES', 'NAV']),
    path(['data', 'response'])
  )(payload)
})

const handleFetchNotificationsFailure = (state, payload) => ({
  ...state,
  isLoaded: false,
  isLoading: false,
  notifications: [],
  error: payload
})

const handleSetNotificationsChecked = (state, payload) => ({
  ...state,
  checkedItems: payload
})

const handleMarkNotifications = (state, payload, { clientApi }) =>
  loop(
    {
      ...state,
      isLoaded: true,
      isLoading: true
    },
    Effects.promise(requestMark({ clientApi }), payload)
  )

const handleMarkNotificationsSuccess = (state, { data, filters: { page, limit, offset, sort, order, filter } }) =>
  loop(
    {
      ...state,
      checkedItems: [],
      success: pathOr('N', ['data', 'response', 'SUCCESS'], data)
    },
    Effects.call(fetchNotifications, { ...filter, page, limit, offset, sort, order })
  )

const handleMarkNotificationsFailure = (state, payload) =>
  loop(
    {
      ...state,
      error: pathOr(errorText, ['response', 'data', 'meta', 'errorDetail'], payload)
    },
    Effects.call(showModal, 'myNotificationError')
  )

const reducer = createReducer(on => {
  on(fetchNotifications, handleFetchNotifications)
  on(fetchNotificationsSuccess, handleFetchNotificationsSuccess)
  on(fetchNotificationsFailure, handleFetchNotificationsFailure)
  on(setNotificationsChecked, handleSetNotificationsChecked)
  on(markNotificationsViewed, handleMarkNotifications)
  on(markNotificationsViewedSuccess, handleMarkNotificationsSuccess)
  on(markNotificationsViewedFailure, handleMarkNotificationsFailure)
}, initialState)

export default reducer
